import { render, staticRenderFns } from "./TwCheckBoxes.vue?vue&type=template&id=74314920&"
import script from "./TwCheckBoxes.vue?vue&type=script&lang=js&"
export * from "./TwCheckBoxes.vue?vue&type=script&lang=js&"
import style0 from "./TwCheckBoxes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports